import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import moment from 'moment';
import { SingleDatePicker } from 'sarsaparilla';
import RenderIf from '../../utils/JSXUtils';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  date: momentPropTypes.momentObj.isRequired,
  displayFormat: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isOutsideRange: PropTypes.func
};

const today = moment().startOf('day');

const defaultProps = {
  label: '',
  displayFormat: 'll',
  isOutsideRange: (day) => day.isBefore(today)
};

export default class SimpleDatePicker extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      focused: false
    };

    this.onFocusChanged = this.onFocusChanged.bind(this);
  }

  onFocusChanged({ focused }) {
    this.setState((prevState) => ({ ...prevState, focused }));
  }

  render() {
    const { id, label, date, displayFormat, className, onChange, isOutsideRange, ...rest } = this.props;
    const { focused } = this.state;
    const classes = `simple-date-picker rec-form-item-wrap ${className}`;

    return (
      <div className={classes}>
        {RenderIf(label)(<label htmlFor={id}>{label}</label>)}
        <SingleDatePicker
          id={id}
          numberOfMonths={1}
          date={date}
          focused={focused}
          displayFormat={displayFormat}
          isOutsideRange={isOutsideRange}
          onDateChange={onChange}
          onFocusChange={this.onFocusChanged}
          {...rest} />
      </div>
    );
  }
}

SimpleDatePicker.propTypes = propTypes;
SimpleDatePicker.defaultProps = defaultProps;
